/**
 * Pin Map shared block scripts
 * This file gets shared between the
 * theme and editor.
 */
const pinMap = document.querySelectorAll('.pin-map');
if (pinMap.length && 'relative' === getComputedStyle(pinMap[0]).position) { // cheep way to see if we're mobile
	pinMap.forEach((map) => {

		// pin rotation
		const pins = map.querySelectorAll('.pin-map__pin');
		const num = pins.length - 1;
		let index = -1;
		const changePin = () => {
			index = index < num ? ++index : 0;
			pins[index].classList.add('active');
			pins[0 <= index - 1 ? index - 1 : num].classList.remove('active');
			setTimeout(() => changePin(), 3000);
		};
		changePin();

	});
}
